import {createContext, useContext} from 'react';

import {componentsTheme, DefaultComponentsTheme} from '../utils/componentsTheme';

const ComponentsThemeContext = createContext<DefaultComponentsTheme>(componentsTheme);

export const ComponentsThemeContextProvider = ComponentsThemeContext.Provider;

export function useComponentsTheme() {
  return useContext(ComponentsThemeContext);
}
